module.exports = __webpack_public_path__ + "static/ammolite-strategies-5b7b0863849a1322f416620e4145c259.png";